var _rect, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasurementPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 480,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 13,
    x: 6,
    y: 29,
    fill: "#3dd9eb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 35.5,
    r: 2.5,
    fill: "#3dd9eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 12,
    x: 9,
    y: 11.5,
    fill: "#f5bc00"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb7900",
    points: "23,19 34,19 33.999,11.449 23,11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 23.5,
    fill: "#f5bc00",
    rx: 12.5,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fae56b",
    d: "M37.5,42H9V29h29.09L44,23.5v12C44,39.09,41.09,42,37.5,42z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 11.5,
    fill: "#fae56b",
    rx: 12.5,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 11.5,
    fill: "#eb7900",
    rx: 4.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M38,29H21.5V17H38c3.314,0,6,2.686,6,6v0C44,26.314,41.314,29,38,29z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 13,
    x: 9,
    y: 29,
    fill: "#00b3d7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 15,
    y: 35,
    fill: "#f5bc00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 21,
    y: 39,
    fill: "#f5bc00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 27,
    y: 35,
    fill: "#f5bc00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 33,
    y: 39,
    fill: "#f5bc00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementPic);
export default __webpack_public_path__ + "static/media/measurement_pic.ca7018b8ce16d69d26ef7e0b4e4d9bf4.svg";
export { ForwardRef as ReactComponent };